import { useUser } from "src/contexts/user-context";
import { useDevSettings } from "src/pages/agents/hooks/use-dev-settings";
import { isHightouchStaffUser } from "src/utils/user";

/** Private files are staff-only, so like Ad Studio's hidden chats their controls show only for staff in Dev mode. */
export function useCanSetFileVisibility(): boolean {
  const { user } = useUser();
  const {
    settings: { isDevMode },
  } = useDevSettings();
  return isHightouchStaffUser(user?.admin_type) && isDevMode;
}
